/* eslint-disable object-shorthand */
// eslint-disable-next-line prefer-destructuring
const replace = String.prototype.replace;
const percentTwenties = /%20/g;

const Format = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986",
};

export default {
  DEFAULT: Format.RFC3986,
  formatters: {
    RFC1738: function (value) {
      return replace.call(value, percentTwenties, "+");
    },
    RFC3986: function (value) {
      return String(value);
    },
  },
  RFC1738: Format.RFC1738,
  RFC3986: Format.RFC3986,
};
